/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FollowupAssignRequest } from '../models/FollowupAssignRequest';
import type { FollowupAssignResource } from '../models/FollowupAssignResource';
import type { FollowupResource } from '../models/FollowupResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FollowupsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create new follow-up for a person.
     * Will send email if applicable.
     * @returns any OK
     * @throws ApiError
     */
    public assignFollowups({
        requestBody,
    }: {
        /**
         * Array of followup assignments to assign to people
         */
        requestBody: Array<FollowupAssignRequest>,
    }): CancelablePromise<{
        data: Array<FollowupAssignResource>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/followups/assign',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Retrieve all followup options.
     * @returns any OK
     * @throws ApiError
     */
    public getFollowups({
        sort,
    }: {
        sort?: string,
    }): CancelablePromise<{
        data: Array<FollowupResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/followups/options',
            query: {
                'sort': sort,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Retrieve a followup by ID.
     * @returns any OK
     * @throws ApiError
     */
    public getFollowup({
        id,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
    }): CancelablePromise<{
        data: FollowupResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/followups/options/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

}
